// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Loading__wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/Loading.scss
// module id = ./src/components/Loading/Loading.scss
// module chunks = 2